(() => {
  'use strict';
  const dialog = document.getElementById('MesserpostDialog');
  const teaser = document.querySelector('[data-messerpost-open]');
  const widget = document.querySelector('[data-messerpost-teaser]');
  const dismissButton = document.querySelector('[data-messerpost-dismiss]');
  if (!dialog || !teaser || !widget || !dismissButton || typeof dialog.showModal !== 'function') return;
  const dismissKey = 'herder-messerpost-hidden-v1';
  let dismissedPermanently = false;
  const isDismissed = () => {
    try { return dismissedPermanently || localStorage.getItem(dismissKey) === 'true'; } catch (_) { return dismissedPermanently; }
  };
  const key = 'herder-messerpost-v1';
  const day = 86400000;
  let timer;
  let previousFocus;
  let autoShown = false;
  let interacted = false;
  const status = dialog.querySelector('[data-messerpost-status]')?.dataset.messerpostStatus;
  const read = () => { try { return JSON.parse(localStorage.getItem(key) || '{}'); } catch (_) { return {}; } };
  const remember = (days, subscribed = false) => {
    try { localStorage.setItem(key, JSON.stringify({ until: Date.now() + days * day, subscribed })); } catch (_) { /* Signup works without storage. */ }
  };
  const busy = () => Array.from(document.querySelectorAll('dialog[open]:not(#MesserpostDialog), [role="dialog"][aria-modal="true"], details[open] .menu-drawer, .shopify-pc__banner')).some(element => {
    const style = getComputedStyle(element);
    return element.getClientRects().length && style.visibility !== 'hidden' && Number(style.opacity) > 0 && !element.closest('details:not([open])');
  }) || /INPUT|TEXTAREA|SELECT/.test(document.activeElement?.tagName || '');
  const open = () => {
    if (dialog.open) return;
    previousFocus = document.activeElement;
    const image = dialog.querySelector('[data-messerpost-image]');
    if (image && !image.getAttribute('src')) image.src = image.dataset.messerpostImage;
    dialog.showModal();
    document.documentElement.classList.add('messerpost-open');
    widget.hidden = true;
    // Do not open the mobile keyboard before the visitor chooses the email field.
    dialog.querySelector('[data-messerpost-close]').focus({ preventScroll: true });
  };
  const close = () => dialog.close();
  dialog.addEventListener('close', () => {
    document.documentElement.classList.remove('messerpost-open');
    if (status !== 'success') { remember(30); widget.hidden = isDismissed(); }
    previousFocus?.focus({ preventScroll: true });
  });
  dialog.querySelectorAll('[data-messerpost-close]').forEach(button => button.addEventListener('click', close));
  dialog.addEventListener('click', event => {
    if (event.target !== dialog) return;
    const rect = dialog.getBoundingClientRect();
    if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) close();
  });
  teaser.addEventListener('click', open);
  dismissButton.addEventListener('click', () => {
    dismissedPermanently = true;
    try { localStorage.setItem(dismissKey, 'true'); } catch (_) { /* Keep hidden for this page when storage is unavailable. */ }
    widget.hidden = true;
    window.clearInterval(timer);
  });
  window.addEventListener('storage', event => {
    if ((event.key === dismissKey || event.key === null) && isDismissed()) {
      widget.hidden = true;
      window.clearInterval(timer);
    }
  });
  if (status) {
    if (status === 'success') remember(365, true);
    open();
    return;
  }
  if (isDismissed() || (read().subscribed && read().until > Date.now())) return;
  const started = Date.now();
  const tick = () => {
    if (isDismissed()) { widget.hidden = true; return; }
    if (document.hidden || busy() || dialog.open) return;
    widget.hidden = false;
    const dismissed = read().until > Date.now();
    if (!autoShown && !dismissed && interacted && Date.now() - started >= 20000) {
      autoShown = true;
      remember(30);
      open();
    }
  };
  window.addEventListener('scroll', () => { if (window.scrollY > 180) interacted = true; }, { passive: true });
  document.addEventListener('pointerdown', () => { interacted = true; }, { once: true, passive: true });
  timer = window.setInterval(() => { tick(); if (autoShown) window.clearInterval(timer); }, 2000);
  window.setTimeout(tick, 5000);
})();
